export default __webpack_public_path__ + "static/media/logo_GoEducate.2e5932dd.svg";